export const randomNumber = (max: number) => {
  return Math.floor(Math.random() * max);
};
